import { useCreateResource } from '@app/src/api/updateHooks'
import { NotificationSeverity } from '@app/src/wf-constants'
import { useSnackbar } from '@app/src/context/SnackbarContext'
import { useIntl } from 'react-intl'
import type { FileResponse } from '../types/api'

type ExportResponse = FileResponse
type ExportRequest = Record<string, unknown>

export const useQueueResponseExport = () => {
  const { showSnackbar } = useSnackbar()
  const { formatMessage } = useIntl()

  return useCreateResource<ExportResponse, ExportRequest>({
    options: {
      onSuccess: () => {
        showSnackbar({
          message: formatMessage({ id: 'notifications.successfulExportQueueRequest' }, { br: '\n' }),
          severity: NotificationSeverity.success,
        })
      },
      onError: () => {
        showSnackbar({
          message: formatMessage({ id: 'notifications.error' }),
          severity: NotificationSeverity.error,
        })
      },
    },
  })
}
